/**
 * Called after the group details call of selected new Group is completed
 */
import { action } from 'satcheljs';
import { orchestrator } from 'satcheljs';
import { getCurrentGroupSmtpAddress } from 'owa-groups-shared-store';
import { lazyOnGetGroupDetailsSucceededInOwaGroupFiles } from 'owa-group-fileshub-actions';
import { lazySetGroupFilesHubCallbacks } from 'owa-group-fileshub-init';

export const onAfterGroupDetailsSucceeded = action(
    'onAfterGroupDetailsSucceeded',
    (groupSmtpAddress: string) => ({
        groupSmtpAddress: groupSmtpAddress,
    })
);

orchestrator(onAfterGroupDetailsSucceeded, async msg => {
    // only if current Group selected is same as the group for which the group details is completed
    if (msg.groupSmtpAddress.toLowerCase() !== getCurrentGroupSmtpAddress().toLowerCase()) {
        return;
    }

    // we need to make sure that all the group files hub call back functions are initialized before we call lazyOnGetGroupDetailsSucceededInOwaGroupFiles as it uses the "tryGetSPAuthToken" which needs to be imported
    await lazySetGroupFilesHubCallbacks.importAndExecute();
    lazyOnGetGroupDetailsSucceededInOwaGroupFiles.importAndExecute(msg.groupSmtpAddress);
});
